import { useMediaQuery } from '@mui/material';

// Phones and portrait tablets (below MUI's `md` breakpoint). The portal has no
// theme provider, so the query is spelled out rather than read from a theme.
export const PORTAL_COMPACT_QUERY = '(max-width: 899.95px)';

export const usePortalCompact = (): boolean => useMediaQuery(PORTAL_COMPACT_QUERY, { noSsr: true });
